import { AppAreaConfig } from '@/funnels/@types'
import female from './female'
import male from './male'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main',
	landing: {
		ids: ['loader-main'],
		route: null, // this route defined in router/index.js
		overrides: [
			{
				matcher: {
					lptype: 'age_selection', // /?safe&lptype=age_selection&lpid=
				},
				ids: ['dynamic-age-18-50'],
			},
			{
				matcher: {
					lptype: 'main_loader', // /?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader'],
			},
			{
				matcher: {
					$or: {
						utm_content: /excel/,
						utm_term: /excel/,
					},
				},
				ids: ['creatives-spreadsheet'],
			},
			{
				matcher: {
					$and: {
						utm_content: /calorie|calculator/,
						utm_campaign: /search/,
					},
				},
				ids: ['creatives-calorie-calculator'],
			},
			{
				matcher: {
					$and: {
						utm_content: /kw_weightloss/,
						utm_source: /google/,
					},
				},
				ids: ['creatives-weight-loss'],
			},
			{
				matcher: {
					$and: {
						utm_content: /kw_fasting/,
						utm_source: /google/,
					},
				},
				ids: ['creatives-fasting'],
			},
			{
				matcher: {
					$and: {
						utm_content: /kw_diet/,
						utm_source: /google/,
					},
				},
				ids: ['creatives-best-diet'],
			},
			{
				matcher: {
					$and: {
						utm_campaign: /^(?=.*gdn)(?=.*fastinggs).*$/,
					},
				},
				ids: ['creatives-fasting-gs'],
			},
		],
	},
	funnel: {
		id: 'ob-universal-funnel',
		route: {
			path: '/main/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'survey',
		},
		slug: 'main',
		theme: 'light',
		locale: [
			'en',
			'de-DE',
			'fr-FR',
			'tr',
			'sv',
			'pl',
			'pt-BR',
			'it-IT',
			'es-ES',
			'es-419',
			'da',
			'nb',
			'nl',
			'ja',
			'ar',
		],
		redirectTo: {
			sex: {
				male: { appArea: male },
				female: { appArea: female },
			},
		},
	},
}

export default appAreaConfig
